module.exports = __webpack_public_path__ + "media/images/subcity-icon-5145536887b6c2ccb47a5719a45c0c36.png";